/**
 * @class service_v3sIconService
 * @memberOf v3sWbtPlayerApp:helper
 */

angular.module('v3sWbtPlayerApp').factory('v3sIconService', function () {

    /**
     * Alle Icons und ihre möglichen Benennungen
     * Historisch gewachsen...
     */
    var icons = [];

    icons["audio"] = "audio";
    icons["beispiel"] = "example";
    icons["example"] = "example";
    icons["calc"] = "calc";
    icons["certificate"] = "certificate";
    icons["contact"] = "contact";
    icons["close"] = "close";
    icons["document"] = "document";
    icons["frage"] = "question";
    icons["question"] = "question";
    icons["gesetzestext"] = "paragraph";
    icons["para"] = "paragraph";
    icons["paragraph"] = "paragraph";
    icons["impressum"] = "impressum";
    icons["imprint"] = "impressum";
    icons["info"] = "info";
    icons["link"] = "link";
    icons["internal"] = "link-internal";
    icons["loesung"] = "solution";
    icons["solution"] = "solution";
    icons["mail"] = "mail";
    icons["merksatz"] = "emphasis";
    icons["money"] = "money";
    icons["multi"] = "multi";
    icons["carousel"] = "multi";
    icons["ok"] = "solution";
    icons["print"] = "print";
    icons["popup"] = "popup";
    icons["release"] = "release";
    icons["save"] = "save";
    icons["speaker"] = "speaker";
    icons["speak"] = "speaker";
    icons["start"] = "start";
    icons["tip"] = "tip";
    icons["emphasis"] = "emphasis";
    icons["emph"] = "emphasis";
    icons["video"] = "video";
    icons["warning"] = "warning";
    icons["law"] = "law";
    icons["jurisdiction"] = "jurisdiction";
    icons["task"] = "task";

    /**
     * Gibt den namen der entsprechenden CSS-Klasse zurück
     * Standardmässig wird die Infoklasse zurückgegeben
     * @param {string} name - der Name des Icons
     * returns {string} iconClass - der Name der CSS-Klasse
     */
    function getIconClass(name) {
        var iconClassPrefix = 'v3s-icon-';
        var iconClass = "";
        if (!!icons[name]) {
            iconClass = iconClassPrefix + icons[name];
        }
        return iconClass;
    }

    return {
        getIconClass : getIconClass
    }
});